export default {
  'EditActGallery.upload': { en: 'Upload', fr: 'Télécharger' },
  'EditActGallery.delete': { en: 'Delete', fr: 'Supprimer' },
};
